module.exports = __webpack_public_path__ + "static/csharp-cfcf0a3cde4471fb6e9ae811ccfc2124.jpg";